import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdicionaisEDescontosEditarComponent } from './adicionais-e-descontos-editar.component';

const routes: Routes = [
  {path:':id', component: AdicionaisEDescontosEditarComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdicionaisEDescontosEditarRoutingModule { }
